import './map-artworks.scss';
import 'leaflet/dist/leaflet.css';
import { MapTabs } from './map-tabs/map-tabs';
import { MapService } from '../../services/mapService';
import { MapView } from '../commons/map-view/map-view';
import { createContext, useEffect, useState } from 'react';
import { type MapLocation } from '../../interfaces/MapLocation';
import type { MapLocationsContext } from '../../interfaces/MapLocationsContext';
import { LoaderSpinner } from '../commons/loader-spinner/loader-spinner';
import { SEO } from '../commons/seo/seo';

export const LocationsContext = createContext<MapLocationsContext|null|any>(null);

export function MapArtworks(){

    const [locations,setLocations]=useState<MapLocation[]|any>([]);
    const [loading, setLoading] = useState(false);
    const [selectedLocation,setSelectedLocation]=useState<MapLocation|any>(null);
    const [,setMapLocationObject]=useState<MapLocationsContext|any>({
        locations: [],
        selectedLocation: null,
    });

    useEffect(()=> {
        setLoading(true);
        MapService().getAllLocations().then((elem:any)=>{
            setLocations(elem.data.data);
            setMapLocationObject(
                (prev:MapLocationsContext) => ({ 
                ...prev,
                locations:elem.data.data,
            }));
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        })
        .finally(()=>{
            setLoading(false);
        })
    },[])


    return(
        <>
                    {loading ? (
                    <div className='page-container'>
                        <LoaderSpinner visible={true} />
                    </div>
                    ) : (
            <LocationsContext.Provider value={{locations,selectedLocation,setSelectedLocation}}>
                <SEO
                title="Les Toiles de la Juine"
                description="Les Toiles de la Juine est une exposition artistique consacrée à la redécouverte du patrimoine médiéval à travers des peintures représentant ses lieux, ses personnages, ses métiers et ses grands événements."
                />
                
                <div className="map-container">
                    <aside className='map-filters'>
                        <MapTabs/>
                    </aside>
                    
                    <div className='map-artworks-grid-container'>
                        <MapView/>
                    </div>
                </div>
            </LocationsContext.Provider>)}
        </>
    )

}